import React from 'react';

const WarningNotification = () => {
    return (
        <svg width={25.846} height={22.603} viewBox="0 0 25.846 22.603">
            <defs>
                <style>
                    {
                        '.prefix__a{fill:none;stroke:#b88f04;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}'
                    }
                </style>
            </defs>
            <path
                className="prefix__a"
                d="M10.979 2.096L1.336 18.189a2.276 2.276 0 001.943 3.414h19.283a2.276 2.276 0 001.946-3.414l-9.64-16.093a2.276 2.276 0 00-3.892 0zM12.922 7.946v4.552M12.922 17.051h.011"
            />
        </svg>
    );
};

export default WarningNotification;
